import React from 'react';

import './Menu.css';

const Menu = (props) => {

	const items = props.items.map((item) => (
		<li key={item.id}>
			<a href={'#'+item.id} id={item.id} onClick={props.handleClickMenu}>
				{item.name}
			</a>
			</li>
		))

  return (
        <div className={"menu " + props.status} >
        	<ul>
        		<li><a href='#bewaar' onClick={props.handleClickSave}>Bewaar</a></li>
		        <li className='openfile'>
		          Open
		          <input onChange={props.handleClickOpen} type="file" />
		        </li>
		        <li><a href='#print' onClick={props.handleClickPrint}>Print</a></li>
		        {items}
        	</ul>
        </div>
    );
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js